import { createSlice } from '@reduxjs/toolkit'

export const openPreviewDRGSlice = createSlice({
    name: 'openPreviewDRG',
    initialState: {
        open: false,
    },
    reducers: {
        setOpenPreviewDRG: (state, action) => {
            state.open = action.payload;
        },
    },
})

export const { setOpenPreviewDRG } = openPreviewDRGSlice.actions;

export const getOpenPreviewDRG = (state) => state.openPreviewDRG.open;

export default openPreviewDRGSlice.reducer